import { Stack, Typography } from '@mui/material'
import type { ReactNode } from 'react'

type Props = {
  title: string
  description?: string
  children: ReactNode
}

export const SettingsSectionShell = ({ title, description, children }: Props) => {
  return (
    <Stack spacing={2}>
      <Typography variant="black-16-semiBold" mb={1}>
        {title}
      </Typography>
      {description && (
        <Typography variant="black-14-normal" color="text.secondary" mb={2}>
          {description}
        </Typography>
      )}
      {children}
    </Stack>
  )
}
